import { AfterViewInit, Component, Injector, Input, Inject, isDevMode, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { Document } from '../../../../models/documents/document';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TableColumn } from '../../../../../@vex/interfaces/table-column.interface';
import { DocumentCreateUpdateComponent } from './document-create-update/document-create-update.component';
import { CrvCreateComponent } from './crv-create/crv-create.component';
import { SelectionModel } from '@angular/cdk/collections';
import { fadeInUp400ms } from '../../../../../@vex/animations/fade-in-up.animation';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { stagger40ms } from '../../../../../@vex/animations/stagger.animation';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatSelectChange } from '@angular/material/select';
import { ConfirmDialogComponent } from '../../../apps/common-dialogs/confirm-dialog/confirm-dialog.component';
import { DocumentService } from 'src/app/services/api/document.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { DocFilters } from 'src/app/models/documents/doc-filters';
import { ComboItem } from 'src/app/models/combo-item';
import { MasterService } from 'src/app/services/api/masters.service';
import { MasterCommon } from 'src/app/models/masters/master-common';
import { ITableParams } from 'src/app/pages/apps/table/models/table-params';
import { TransferData } from 'src/app/models/contacts/transfer-data';
import { KeyValue } from 'src/app/models/key-value';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonService } from 'src/app/services/api/common.service';
import { CommonFilter } from 'src/app/models/masters/common-filter';
import { Console } from 'console';
import { CrvHistory } from 'src/app/models/documents/crv-history';
import { ListComponent } from 'src/app/pages/apps/table/list/list.component';
import { DocumentationReportComponent } from './documentation-report/documentation-report.component';

@UntilDestroy()
@Component({
  selector: 'vex-documents',
  templateUrl: './documents-table.component.html',
  styleUrls: ['./documents-table.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'standard'
      } as MatFormFieldDefaultOptions
    }
  ]
})
export class DocumentsTableComponent implements OnInit, AfterViewInit {

  @ViewChild(MatAutocompleteTrigger) autoModel: MatAutocompleteTrigger;
  referenceCtl = new FormControl();
  filteredOptions: Observable<string[]>;


  initialized: boolean = false;
  @Input() documentType: string = "";
  @Input() reference: KeyValue = null;
  @Input() editabled: boolean = false;
  _tableData: Array<Document>;
  @Input()
  set tableData(val: Array<Document>) {
    this.tableDataChange.emit(val);
    this._tableData = val;
  }
  get tableData() {
    return this._tableData;
  }
  @Output()
  tableDataChange: EventEmitter<Array<Document>> = new EventEmitter<Array<Document>>();
  @Input() isMenu: boolean = true;
  @Input() params: ITableParams<Document, Document>;

  layoutCtrl = new UntypedFormControl('fullwidth');
  filters: DocFilters = new DocFilters();
  type: number;

  documentTypeId: number;
  documentCategoryId: number;
  categories: Array<ComboItem>;

  subject$: ReplaySubject<Document[]> = new ReplaySubject<Document[]>(1);
  data$: Observable<Document[]> = this.subject$.asObservable();
  documents: Document[];

  docTypes: Array<ComboItem>;
  docCatTypes: Array<ComboItem>;

  @Input()
  columns: TableColumn<Document>[];
  total = 0;
  pageSize = 10;
  pageIndex = 0;
  order = "asc";
  orderType = "";
  pageSizeOptions: number[] = [5, 10, 20, 50];
  dataSource: MatTableDataSource<Document> | null;
  selection = new SelectionModel<Document>(true, []);

  public service: any;
  items: Array<ComboItem> = [];
  CRVservice: string = 'documents/crv';
  CRVdata: any;
  showGenerateButton: boolean = true;
  paramsHistory: ITableParams<CrvHistory, CrvHistory> = null;
  historyColumns: Array<TableColumn<CrvHistory>>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private dialog: MatDialog,
    private alert: ToastService,
    private documentService: DocumentService,
    private masterService: MasterService<MasterCommon>,
    private commonService: CommonService<Document, DocFilters>,
    private dialogRef: MatDialogRef<DocumentsTableComponent>,) {
    this.dataSource = new MatTableDataSource();
  }

  get visibleColumns() {
    if (this.columns)
      return this.columns.filter(column => column.visible).map(column => column.property);

    return [];
  }

  getData() {
    if (this.params?.tableData !== undefined) {
      return of(this.params.tableData);
    }
    else if (this.documents !== undefined)
      return of(this.documents);
    else
      return of([])
  }

  ngOnInit() {
    
    const appUser = JSON.parse(localStorage.getItem("currentUser"));
    if(this.isMenu)
      this.editabled = appUser.roles.filter(y => y.id == 1 || y.id == 2 || y.id == 3 || y.id == 4 || y.id == 7 || y.id == 8).length > 0;

    if(appUser.roles.filter(y => y.id == 7).length > 0)
      this.editabled = true;

    (async () => {

      this.categories = await this.masterService.get("documentCategory") as unknown as Array<MasterCommon>;
      this.docTypes = await this.masterService.get("documentTypes") as unknown as Array<MasterCommon>;
      this.docCatTypes = await this.masterService.get("documentCategoryTypes") as unknown as Array<MasterCommon>;
    
      this.columns = [
        { label: 'Casilla de selección', property: 'checkbox', type: 'checkbox', visible: this.editabled && this.documentType != 'CRV' },
        { label: 'Fecha de subida', property: 'createdAt', type: 'date', visible: true },
        { label: 'Tipo de Categoría', property: 'documentCategoryTypes', type: 'select', visible: true },
        { label: 'Categoría', property: 'documentCategory', type: 'select', visible: true },
        { label: 'Tipo', property: 'documentType', type: 'select', visible: true },
        { label: 'Referencia', property: 'referenceName', type: 'text', visible: true, },
        { label: 'Notas', property: 'description', type: 'text', visible: false, },
        { label: 'Firmado', property: 'isSigned', type: 'flag', visible: this.documentType == 'CRV', },
        { label: 'Visualizar', property: 'view', type: 'button', visible: true },
        { label: 'Acciones', property: 'actions', type: 'button', visible: this.editabled }
      ];

      if (this.data?.reference) {
        this.reference = this.data.reference;
        this.documentTypeId = this.data.documentTypeId;
        this.documentType = this.data.type;
        this.documentCategoryId = this.data.documentCategoryId;
        this.filters.documentCategoryId = this.data.documentCategoryId;
        this.params = {
          root: ["Gestión de expedientes", "Expedientes de venta", "Documentos"],
          //tableData: this.data.tableData || [],
          isMenu: false,
          disabledMode: true,
          element: "Documento",
          title: 'Documentos',
          titleProperty: "name",
          columns: this.columns
        }
      }
      else {
        this.params = this.data;
      }

      if (this.reference){
        this.filters.referenceName = this.reference?.name;
        this.filters.referenceId = this.reference?.id;
      }
      if (this.documentType && this.documentType != 'CRV') {
        
        this.documentTypeId = this.docTypes.filter(d => d.name === this.documentType)[0]?.id;

        if (this.documentTypeId == 3 && (this.getFirstXCharacters(this.filters.referenceName, 4) == 'EXVV' || this.getFirstXCharacters(this.filters.referenceName, 4) == 'EXEV')) {
          this.modalCRV();
        }
        else{
          this.showGenerateButton = false;
        }
      } else {
        this.showGenerateButton = false;
        if (this.documentType == 'CRV') {

          let categoryCRV = this.categories.filter(d => d.name == 'CRV');

          this.documentCategoryId = categoryCRV[0].id

          this.filters.documentCategoryId = this.documentCategoryId;
        }
      }

      if (this.reference && !this.documentType)

      if (this.params?.columns != undefined) {
        this.isMenu = this.params.isMenu;
        this.columns = this.params.columns;
      }

      // Para el histórico de envíos
        this.historyColumns = [
          { label: 'Fecha de envío', property: 'createdAt', type: 'date', visible: true },
          { label: 'Nombre del archivo', property: 'name', type: 'text', visible: true },
          { label: 'Destinatario', property: 'entityReceiver', type: 'text', visible: true },
          { label: 'Comercial', property: 'userReceiver', type: 'text', visible: true },
        ];

        this.paramsHistory = {
          isMenu: false,
          title: 'Historial de envíos',
          titleProperty: "name",
          hasImage: false,
          disabledMode: true,
          columns: this.historyColumns,
          tableData: []
        };

      this.loadData();
    })();    
  }

  ngAfterContentInit() {
    if (this.dataSource) {
      //this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  sortData(event) {
    this.orderType = event.active;
    this.order = event.direction;
    this.loadData();
  }
  
  loadFilters() {
    this.filters.pageNumber = this.pageIndex + 1;
    this.filters.rowsPerPage = this.pageSize;
    this.filters.order = this.order;
    this.filters.orderBy = this.orderType;
    this.filters.documentTypeId = this.documentTypeId || this.filters.documentTypeId;

  }

  base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  downloadFile(doc: Document) {
    this.documentService.getDocument(doc).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No se ha podido descargar el documento " + doc.name);
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            var pdfResult = response.base64; 

            var file = this.base64toBlob(pdfResult, doc.mimeType);
            //var file = new Blob([pdfResult], {type: 'application/pdf'}); //{type: doc.file.mime});
            var fileURL = URL.createObjectURL(file);
            var anchor = document.createElement("a");
            anchor.download = doc.originalName;
            anchor.href = fileURL;
            anchor.click();
          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No se ha podido descargar el documento " + doc.originalName);
        }
    });
  }

  viewFile(doc: Document) {
    this.documentService.getDocument(doc).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No se ha podido abrir el documento " + doc.name);
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            var pdfResult = response.base64;
            var file = this.base64toBlob(pdfResult, response.mimeType);
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
          }
        },
      error:
      (e) => {
        if (e.status == '401') {
          this.router.navigate(['/login']);
          this.alert.info("Sesión expirada")
          return;
        }
        if (isDevMode)
          this.alert.error(e.message)
        else
          this.alert.error("No se ha podido abrir el documento " + doc.originalName);
      }
    });
  }

  closeReference(event) {
    this.filters.documentTypeId = null;
    //this.filters.referenceId = null;
    this.items = [];
    this.loadData();
    event.stopPropagation()
  }

  changeType(type: any) {
    this.loadData();
  }
  loadData() {
    if (this.documentType)
      this.documentTypeId = this.docTypes.filter(d => d.name === this.documentType)[0]?.id;
    this.loadFilters();
    this.documentService.getAll(this.filters)
      .subscribe({
        next:
          response => {
            if (!response) {
              this.alert.error("No hay documentos");
            }
            else if (!response.isSuccessful) {
              this.alert.info(response.message);
            }
            else {
              this.documents = response.data.map(d => new Document(d));
              this.paginator.length = response.total;
              this.paginator.pageIndex = this.pageIndex;
              //this.paginator.page = Math.ceil(response.total/this.pageSize);
              this.subsribeData()
            }
          },
        error:
          (e) => {
            if (e.status == '401') {
              this.router.navigate(['/login']);
              this.alert.info("Sesión expirada")
              return;
            }
            if (isDevMode)
              this.alert.error(e.message)
            else
              this.alert.error("No ha sido posible recuperar la lista de documentos");
          }
      })
  }

  subsribeData() {
    this.getData().subscribe(documents => {
      this.subject$.next(documents);
    });


    this.data$.pipe(
      filter<Document[]>(Boolean)
    ).subscribe(documents => {
      this.documents = documents;
      this.dataSource.data = documents;
    });
  }

  ngAfterViewInit() {
    if (this.dataSource) {
      this.paginator.length = this.total;
      this.dataSource.sort = this.sort;

    }
  }

  createDocument() {
    this.dialog.open(DocumentCreateUpdateComponent, {
      disableClose: true,
      data: new TransferData({
        type: this.documentType,
        reference: this.reference ? this.reference : 'Documents',
        documentCategoryId: this.documentCategoryId

      })
    }).afterClosed().subscribe((documents: Array<Document>) => {
      this.loadData();
    });
  }

  getFirstXCharacters(name: string, ext: number): string {
    return name.slice(0, ext);
  }

  createCRV(){
    this.dialog.open(CrvCreateComponent, {
      data: {
        CRVdata: this.CRVdata || null,
        documentType: this.documentType
      }
    }).afterClosed().subscribe((documents: Array<Document>) => {
      this.modalCRV();
      this.loadData();
    });
  }

  modalCRV(){
    this.commonService.getAll(this.CRVservice, this.filters).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No hay documentos");
            this.showGenerateButton = false;
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
            this.showGenerateButton = false;
          }
          else {
            this.CRVdata = response.data;
            if (this.CRVdata.documents.length == 0) this.showGenerateButton = false;
            this.CRVdata.adminFileId = this.filters.referenceId
          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No ha sido posible recuperar la lista de documentos");
        }
    })
  }

  updateDocument(document: Document) {

    document.signed = false;

    if (this.editabled && this.documentType != 'Vehículo') {
      this.dialog.open(DocumentCreateUpdateComponent, {
        disableClose: true,
        data: new TransferData({
          values: document,
          type: this.documentType,
          reference: this.reference,
          documentCategoryId: this.documentCategoryId
        })
      }).afterClosed().subscribe(updatedDocument => {
        if (updatedDocument) {
          this.loadData();
        }
      });
    }
  }

  showDeleteDocumentsAlert(documents: Document[]): void {
    if (documents.length == 0) {
      return;
    }
    else if (documents.length == 1) {
      this.showDeleteDocumentAlert(documents[0]);
      return;
    }

    this.dialog
      .open(ConfirmDialogComponent, {
        data: `¿Está seguro de querer eliminar los documentos seleccionados?`
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.deleteDocuments(documents);
        }
      });
  }

  showDeleteDocumentAlert(document: Document): void {

    this.dialog
      .open(ConfirmDialogComponent, {
        data: `¿Está seguro de querer eliminar el documento?`
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.deleteDocument(document);
          this.modalCRV();
        }
      });
  }

  deleteDocument(document: Document) {
    this.documentService.delete(document).subscribe({
      next:
        response => {
          this.selection.deselect(document);
          if (!response) {
            this.alert.error("No se ha podido borrar el documento " + document.name);
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            this.loadData();
            /*  this.documents.splice(this.documents.findIndex((existingDocument) => existingDocument.id === document.id), 1);
             this.selection.deselect(document);
             this.subject$.next(this.documents); */
          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No se ha podido borrar el documento " + document.name);
        }
    });

  }

  deleteDocuments(documents: Document[]) {
    documents.forEach(c => this.deleteDocument(c));
    this.modalCRV();
  }

  onFilterChange(value: string) {
    //this.loadData();
    /*  if (!this.dataSource || !value) {
       return;
     }
     value = value.toString().trim();
     value = value.toString().toLowerCase();
     this.dataSource.filter = value; */

  }

  toggleColumnVisibility(column, event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const page = this.dataSource['_renderData']['_value'].length;
    return numSelected === page;
  }
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.selectRows();
  }
  selectRows() {
    let total = this.pageSize;
    let initIndex: number = 0;
    if (this.pageIndex > 0 && this.dataSource['_renderData']['_value'].length !== this.dataSource.data.length) {
      initIndex = (this.pageIndex) * this.pageSize;
      total = this.pageSize * (this.pageIndex + 1);
    }
    for (let index = initIndex; index < total; index++) {
      if (this.dataSource.data[index])
        this.selection.select(this.dataSource.data[index]);
    }
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  onLabelChange(change: MatSelectChange, row: Document) {
    const index = this.documents.findIndex(c => c === row);
    //this.documents[index].labels = change.value;
    this.subject$.next(this.documents);
  }

  mouseLeave(trigger) {
    trigger.closeMenu();
  }

  closeMenu(trigger) {
    trigger.closeMenu();
  }

  onPaginateChange(event) {
    this.selection.clear();
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.loadData()
  }

  getColor(amount) {
    if (amount < 0)
      return 'red'
    else
      return ''

  }
  close() {
    this.dialogRef.close();
  }

  openFullAggregatorsList(event: Event, trigger: MatAutocompleteTrigger) {
    event.stopPropagation();
    trigger.openPanel();
  }

  public _filter(value: any): any[] {
    if (value == null)
      value = '';
    return this.items.filter(option => option.name.toLowerCase().includes(value?.toLowerCase()));
  }

  sendCRV(element) {

    this.commonService.any("documents/crv/send", element).subscribe({
      next: response => {
        if (!response) {
          this.alert.error("No ha sido posible enviar el CRV");
        } else if (!response.isSuccessful) {
          this.alert.info(response.message);
        } else {
          this.alert.info("CRV enviado");
        }
      },
      error: e => {
        this.alert.error("Error en el envío de la documentación.");
      }
    });

  }

  history(element) {
    this.commonService.getAll("documents/crv/history", element).subscribe({
      next: response => {
        if (!response) {
          this.alert.error("No ha sido posible enviar el CRV");
        } else if (!response.isSuccessful) {
          this.alert.info(response.message);
        } else {
          if (response.data.length > 0) {
            this.paramsHistory.tableData = [];
            this.paramsHistory.tableData = response.data.map(item => new CrvHistory(item));
            this.dialog.open(ListComponent,
              {
                data: this.paramsHistory
              });
          }
          else {
            this.alert.info("Este documento no se ha enviado antes")
          }
        }
      },
      error: e => {
        this.alert.error("Error en el envío de la documentación.");
      }
    });
  }

  sign(document: Document) {

    document.signed = true;

    this.dialog.open(DocumentCreateUpdateComponent, {
        disableClose: true,
        data: new TransferData({
          values: document,
          type: this.documentType,
          reference: this.reference,
          documentCategoryId: this.documentCategoryId,
        })
      }).afterClosed().subscribe(updatedDocument => {
          this.loadData();
      });
  }

  generateReport() {
    this.dialog.open(DocumentationReportComponent, {
      data: new TransferData({
        values: this.filters.referenceId
      })
    })
  }

}

